<template>
    <div class="container">
        <div class="pt-5">
            <h1 class="h3">Settings</h1>
            <div class="py-2">

                <settings-menu></settings-menu>
            </div>
            <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
            <h3 class="h3">Inventory and Orders settings</h3>
            <small>View and update your store details </small>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="float-right">
                    <button @click="saveInventorySettings" class="btn btn-primary px-3">Save Changes</button>
                </div>
                </div>
                </div>

                <div class="container text-left mb-5">
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Stock Buffer<small class="text-danger">*</small></h6>
                        <small>
                             Allow selling items even if they are below Zero
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.has_stock_buffer" id="stock-buffer">
                            <label class="custom-control-label" for="stock-buffer"><small>Enable</small></label>
                        </div>
                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Show stock<small class="text-danger">*</small></h6>
                        <small>
                         Allow employees to see stock count on the <a href="/makesale">make sale page</a>
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.allow_employees_see_stock_count" id="see-stock">
                            <label class="custom-control-label" for="see-stock"><small>Enable</small></label>
                        </div>

                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Allow employees to see payment summaries<small class="text-danger">*</small></h6>
                        <small>
                        This will show summary based on payment method on orders page
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.allow_summaries" id="see_allow_summaries">
                            <label class="custom-control-label" for="see_allow_summaries"><small>Enable</small></label>
                        </div>

                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Employees can delete pending orders<small class="text-danger">*</small></h6>
                        <small>
                         Allow employees to see delete orders that are pending
                            </small>
                    </div>
                        <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.allow_employees_delete_orders" id="delete-orders">
                            <label class="custom-control-label" for="delete-orders"><small>Enable</small></label>
                        </div>

                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Skip Checkout done page<small class="text-danger">*</small></h6>
                        <small>
                     On validating payment go directly to print receipt page
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.skip_checkout_done" id="skip_checkout_done">
                            <label class="custom-control-label" for="skip_checkout_done"><small>Enable</small></label>
                        </div>

                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Enable Wholesale<small class="text-danger">*</small></h6>
                        <small>
                             Allow selling of goods and services with wholesale prices
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.has_wholesale" id="has-wholesale">
                            <label class="custom-control-label" for="has-wholesale"><small>Enable</small></label>
                        </div>
                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Enable Two Step Verification for Orders<small class="text-danger">*</small></h6>
                        <small>
                            Double Verify Orders. This apply mostly for items/services that is paid and will be collected later
                        </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.has_order_verification" id="has-order-verification">
                            <label class="custom-control-label" for="has-order-verification"><small>Enable</small></label>
                        </div>
                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Items can have images<small class="text-danger"></small></h6>
                        <small>
                           On the make sales page item images can be displayed
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.items_have_images" id="items-image">
                            <label class="custom-control-label" for="items-image"><small>Enable</small></label>
                        </div>
                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Items have expiry date<small class="text-danger"></small></h6>
                        <small>
                          You can enable this and edit expiry date per item in <a href="/inventory">inventory</a>
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.expiry_date" id="expiry-date">
                            <label class="custom-control-label" for="expiry-date"><small>Enable</small></label>
                        </div>
                    </div>
                    </div>
                    <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Hide all orders<small class="text-danger">*</small></h6>
                        <small>
                         Employees with no rights to manage orders wont be able to see sales orders
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.hide_orders_from_employees" id="cant-see-orders">
                            <label class="custom-control-label" for="cant-see-orders"><small>Enable</small></label>
                        </div>
                    </div>
                    </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Stock Alerts<small class="text-danger">*</small></h6>
                        <small>
                             Get notifications when stock is low
                             (This is only email and SMS)
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" v-model="inventorySettings.stock_alert" id="stock-alert">
                            <label class="custom-control-label" for="stock-alert"><small>Enable</small></label>
                        </div>
                    </div>
                </div>

                <div class="row py-3 border-bottom" v-if="inventorySettings.stock_alert">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Minimum Stock</h6>
                        <small>
                              General stock low limit
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input type="number" v-model="inventorySettings.minimums_stock" class="form-control" />
                        <small>You can change for individual item on the <a href="/products">inventory page</a></small>
                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Orders Prefix</h6>
                        <small>
                              You can set your orders prefix like DUKA. So you orders number will start with DUKA-*
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input type="text" v-model="inventorySettings.receipt_prefix" class="form-control" />

                    </div>
                </div>
                <div class="row py-3 border-bottom">
                    <div class="col-md-6 col-sm-12">
                        <h6 class="py-1">Orders start number</h6>
                        <small>
                              You can set your order starting number eg. SALE-01. So you receipt will start from 01
                            </small>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <input type="number" v-model="inventorySettings.receipt_no_suffix" class="form-control" />

                    </div>
                </div>
                <hr/>
                <!-- <div class="container">
                     <div class="float-right">
                         <button @click="saveInventorySettings" class="btn btn-primary px-3">Save Changes</button>
                </div> -->
            <!-- </div> -->
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "profile",
        data() {
            return {
                inventorySettings: {

                }
            }
        },
        mounted() {
            this.getUserCompanySettings()
        },
        methods: {

            getUserCompanySettings() {
                axios.get('/api/settings')
                    .then(results => {

                       this.inventorySettings = results.data


                    }).catch(errors => {
                        console.log(errors.message)
                    });
            },
            saveInventorySettings() {
                axios.post('/api/settings/inventory', { ...this.inventorySettings
                }).then(results => {
                    if(results.status === 200)
                    {
                        this.$toasts.push({
                        type: 'success',
                        message: "Settings updated"
                         })
                         window.location.reload()
                    }

                }).catch(errors => {
                })
            }
        },
    }
</script>

<style scoped>

</style>
